module.exports = __webpack_public_path__ + "media/images/85/weight_loss_bed-f19437bdf916c9828e3ad4ab7d5988bf.webp";